import axios from 'axios'
import {ShopModel, PostModel, ProductModel, ParentCategoryModel} from './ProfileModels'

const API_URL = process.env.REACT_APP_API_URL

export const GET_SHOP_URL = `${API_URL}/get_shop`
export const GET_POSTS_URL = `${API_URL}/get_posts`
export const GET_CAT_URL = `${API_URL}/get_categories`
export const GET_PROUDCTS_URL = `${API_URL}/get_proudcts`
export const GET_SHOP_SHAREHOLDERS_URL = `${API_URL}/get_shop_shareholders`

export function getShopByUsername(username: string) {
  return axios.post<ShopModel>(GET_SHOP_URL, {
    username: username,
  })
}

export function getShopPosts(shopId: string) {
  return axios.post<PostModel>(GET_POSTS_URL, {
    shopId: shopId,
  })
}

export function getShopProducts(shopId: string) {
  return axios.post<ProductModel>(GET_PROUDCTS_URL, {
    shopId: shopId,
  })
}

export function getShopCategories() {
  return axios.post<ParentCategoryModel[]>(GET_CAT_URL, {})
}

export function getShopShareholders(shopId: string) {
  return axios.post(GET_SHOP_SHAREHOLDERS_URL, {
    shopId: shopId,
  })
}
